import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { clearSavedSearchView } from "../../../redux/features/savedSearchView/savedSearchViewSlice";

export function useSavedSearchView() {
  const { id: ruleId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearSavedSearchView());
    };
  }, [dispatch]);

  return { ruleId };
}
